import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { datasetUrl } from '@/constants/urls';
import { readStates, states } from '@/constants/lifecycle';
import fetch, { fetchConfig } from '@/hooks/fetch';
import { fetchCatalogue } from '../../catalogue/actions';

const DatasetAdminPanelHeader = ({
  category,
  className,
  code,
  fetchData,
  name,
  onChange,
  url,
  readStatus,
}) => {
  const intl = useIntl();
  fetch.useFetchByCode(fetchData, category, code, readStatus, fetchConfig([category, code, readStatus]));
  const isLoading = readStatus === states.PENDING;
  if (onChange && readStatus === states.SUCCESS) {
    const title = intl.formatMessage({ id: 'tabs.admin.of' }, { name });
    onChange({ url, title });
  }

  return (
    <Header
      as="a"
      href={datasetUrl({ code }, '#')}
      color="blue"
      className={clsx('aridhia-dataset-admin-panel-header aridhia-h2', className)}
      rel="noopener noreferrer"
    >
      <Icon loading={isLoading} name={isLoading ? 'circle notch' : 'sliders'} className="primary" />
      <Header.Content content={intl.formatMessage({ id: 'tabs.admin.of' }, { name })} />
    </Header>
  );
};

export const mapStateToProps = ({
  catalogues: { catalogues },
}, { category, code }) => {
  const item = findResult(catalogues, category, code) || {
    catalogue: { title: '' },
    ...readStates,
  };

  return {
    name: item.catalogue.title,
    readStatus: item.readStatus,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchCatalogue,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetAdminPanelHeader);
